import { useNavigate } from 'react-router';
import SendFeedbackPanel from '../Components/Feedback/SendFeedbackPanel';

import styles from '../styles/DynamicModal.module.css';

export default function SendFeedbackPage() {
  const navigate = useNavigate();
  return (
    <div className={styles.liningOver} style={{ backgroundColor: '#00000000' }}>
      <SendFeedbackPanel closeModal={() => navigate('/')} />
    </div>
  );
};
